var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmurgo = function SvgEmurgo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 87 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#emurgo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.612 12.986c-.402 0-.782-.103-1.115-.287a2.16 2.16 0 0 1-.793-.816c-.195-.356-.287-.759-.287-1.218 0-.449.103-.862.287-1.219a2 2 0 0 1 .793-.816 2.15 2.15 0 0 1 1.115-.287c.402 0 .781.103 1.115.287.333.196.597.471.793.816.195.357.287.759.287 1.219s-.103.862-.287 1.218-.46.62-.793.816a2.2 2.2 0 0 1-1.115.287m0 1.908c.862 0 1.632-.184 2.321-.54a4 4 0 0 0 1.61-1.517q.585-.966.586-2.172 0-1.207-.587-2.173a4.2 4.2 0 0 0-1.609-1.517c-.678-.356-1.46-.54-2.321-.54s-1.632.184-2.322.54a3.94 3.94 0 0 0-1.609 1.517q-.585.966-.586 2.172 0 1.208.586 2.173c.39.643.931 1.15 1.61 1.517.689.356 1.459.54 2.32.54m-8.252-2.172c-.38.172-.793.264-1.242.264s-.839-.103-1.195-.299a2.14 2.14 0 0 1-.816-.816c-.195-.356-.287-.747-.287-1.207 0-.7.218-1.264.632-1.689.425-.425.988-.632 1.678-.632.77 0 1.425.299 1.977.908l1.47-1.322c-.401-.483-.907-.839-1.516-1.103-.61-.253-1.287-.38-2.046-.38-.862 0-1.644.173-2.333.54-.69.357-1.23.863-1.61 1.506a4.25 4.25 0 0 0-.585 2.184c0 .816.195 1.54.586 2.184.38.643.92 1.15 1.609 1.505.678.357 1.448.54 2.299.54a6.6 6.6 0 0 0 1.815-.264 5 5 0 0 0 1.61-.77v-3.367H67.37v2.218zm-9.758-3.115c0 .38-.126.678-.356.874q-.362.31-1.07.31h-1.275v-2.38h1.276q.706 0 1.069.311c.241.207.356.506.356.885m.023 5.126h2.46l-1.747-2.551a2.68 2.68 0 0 0 1.183-1.035c.276-.437.414-.954.414-1.54 0-.609-.15-1.15-.437-1.597-.287-.449-.712-.793-1.252-1.046-.54-.242-1.184-.368-1.92-.368h-3.735v8.126h2.299V12.56h1.252zm-11.102.161c1.206 0 2.149-.333 2.815-.988.667-.655 1.012-1.586 1.012-2.805V6.607h-2.264v4.437c0 1.298-.517 1.954-1.54 1.954-1.035 0-1.54-.655-1.54-1.954V6.607h-2.3v4.506c0 1.207.334 2.138 1.012 2.804.655.644 1.61.977 2.805.977m-6.069-.16V6.606h-1.896l-2.782 4.69-2.861-4.69H31.03v8.126h2.126v-4.195l2.08 3.39h1.012l2.091-3.505v4.31zm-15.7-1.782v-1.494h3.61V9.734h-3.61V8.366h4.104V6.584H22.49v8.126h6.529v-1.77h-4.264z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__b)",
    d: "M13.882 5.86a1.839 1.839 0 1 0 0-3.677 1.839 1.839 0 0 0 0 3.677"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__c)",
    d: "M16.859 9.791a1.678 1.678 0 1 0 0-3.356 1.678 1.678 0 0 0 0 3.356"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__d)",
    d: "M16.859 14.894a1.529 1.529 0 1 0 0-3.057 1.529 1.529 0 0 0 0 3.057"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__e)",
    d: "M13.882 18.825a1.38 1.38 0 1 0 0-2.759 1.38 1.38 0 0 0 0 2.759"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__f)",
    d: "M8.963 20.273a1.218 1.218 0 1 0 0-2.437 1.218 1.218 0 0 0 0 2.437"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__g)",
    d: "M4.067 18.514a1.069 1.069 0 1 0 0-2.138 1.069 1.069 0 0 0 0 2.138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__h)",
    d: "M1.079 14.273a.908.908 0 1 0 0-1.815.908.908 0 0 0 0 1.815"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__i)",
    d: "M1.079 8.872a.759.759 0 1 0 0-1.517.759.759 0 0 0 0 1.517"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__j)",
    d: "M4.067 4.63a.61.61 0 1 0 0-1.217.61.61 0 0 0 0 1.218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__k)",
    d: "M8.963 4.412a1.988 1.988 0 1 0 0-3.976 1.988 1.988 0 0 0 0 3.976"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__l)",
    d: "M11.538 8.504a1.011 1.011 0 1 0 0-2.023 1.011 1.011 0 0 0 0 2.023"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__m)",
    d: "M13.18 10.688a.931.931 0 1 0 .001-1.862.931.931 0 0 0 0 1.862"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__n)",
    d: "M13.18 13.515a.839.839 0 1 0 .001-1.678.839.839 0 0 0 0 1.678"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__o)",
    d: "M11.538 15.687a.759.759 0 1 0 0-1.517.759.759 0 0 0 0 1.517"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__p)",
    d: "M8.814 16.491a.678.678 0 1 0 0-1.356.678.678 0 0 0 0 1.356"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__q)",
    d: "M6.09 15.515a.586.586 0 1 0 0-1.173.586.586 0 0 0 0 1.173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__r)",
    d: "M4.435 13.181a.506.506 0 1 0 0-1.011.506.506 0 0 0 0 1.011"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__s)",
    d: "M4.435 10.182a.425.425 0 1 0 0-.85.425.425 0 0 0 0 .85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__t)",
    d: "M6.09 7.826a.333.333 0 1 0 0-.667.333.333 0 0 0 0 .667"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__u)",
    d: "M8.813 7.71a1.103 1.103 0 1 0 0-2.206 1.103 1.103 0 0 0 0 2.207"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__v)",
    d: "M9.986 10.032a.46.46 0 1 0 0-.92.46.46 0 0 0 0 .92"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__w)",
    d: "M10.733 11.02a.425.425 0 1 0 0-.85.425.425 0 0 0 0 .85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__x)",
    d: "M10.732 12.285a.38.38 0 1 0 0-.759.38.38 0 0 0 0 .759"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__y)",
    d: "M9.985 13.274a.345.345 0 1 0 0-.69.345.345 0 0 0 0 .69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__z)",
    d: "M8.767 13.641a.31.31 0 1 0 0-.62.31.31 0 0 0 0 .62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__A)",
    d: "M7.537 13.193a.264.264 0 1 0 0-.529.264.264 0 0 0 0 .529"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__B)",
    d: "M6.79 12.136a.23.23 0 1 0 0-.46.23.23 0 0 0 0 .46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__C)",
    d: "M6.79 10.791a.196.196 0 1 0 0-.391.196.196 0 0 0 0 .391"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__D)",
    d: "M7.538 9.723a.15.15 0 1 0 0-.3.15.15 0 0 0 0 .3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emurgo_svg__E)",
    d: "M8.767 9.676a.494.494 0 1 0 0-.988.494.494 0 0 0 0 .988"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__b",
    x1: 1.187,
    x2: 15.411,
    y1: 16.721,
    y2: 2.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__c",
    x1: 4.689,
    x2: 18.912,
    y1: 20.283,
    y2: 6.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__d",
    x1: 7.292,
    x2: 21.515,
    y1: 22.931,
    y2: 8.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__e",
    x1: 7.839,
    x2: 22.063,
    y1: 23.489,
    y2: 9.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__f",
    x1: 6.199,
    x2: 20.422,
    y1: 21.82,
    y2: 7.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__g",
    x1: 2.972,
    x2: 17.195,
    y1: 18.537,
    y2: 4.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__h",
    x1: -0.529,
    x2: 13.694,
    y1: 14.975,
    y2: 0.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__i",
    x1: -3.132,
    x2: 11.091,
    y1: 12.326,
    y2: -1.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__j",
    x1: -3.68,
    x2: 10.544,
    y1: 11.768,
    y2: -2.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__k",
    x1: -2.044,
    x2: 12.18,
    y1: 13.433,
    y2: -0.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__l",
    x1: 1.743,
    x2: 15.967,
    y1: 17.286,
    y2: 3.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__m",
    x1: 3.68,
    x2: 17.904,
    y1: 19.257,
    y2: 5.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__n",
    x1: 5.126,
    x2: 19.35,
    y1: 20.728,
    y2: 6.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__o",
    x1: 5.427,
    x2: 19.65,
    y1: 21.034,
    y2: 6.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__p",
    x1: 4.521,
    x2: 18.744,
    y1: 20.113,
    y2: 5.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__q",
    x1: 2.729,
    x2: 16.952,
    y1: 18.289,
    y2: 4.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__r",
    x1: 0.791,
    x2: 15.015,
    y1: 16.318,
    y2: 2.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__s",
    x1: -0.654,
    x2: 13.569,
    y1: 14.846,
    y2: 0.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__t",
    x1: -0.955,
    x2: 13.268,
    y1: 14.541,
    y2: 0.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__u",
    x1: -0.046,
    x2: 14.178,
    y1: 15.466,
    y2: 1.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__v",
    x1: 2.009,
    x2: 16.233,
    y1: 17.557,
    y2: 3.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__w",
    x1: 2.884,
    x2: 17.108,
    y1: 18.448,
    y2: 4.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__x",
    x1: 3.535,
    x2: 17.758,
    y1: 19.11,
    y2: 4.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__y",
    x1: 3.672,
    x2: 17.895,
    y1: 19.249,
    y2: 5.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__z",
    x1: 3.265,
    x2: 17.488,
    y1: 18.835,
    y2: 4.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__A",
    x1: 2.458,
    x2: 16.681,
    y1: 18.014,
    y2: 3.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__B",
    x1: 1.583,
    x2: 15.806,
    y1: 17.123,
    y2: 2.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__C",
    x1: 0.921,
    x2: 15.172,
    y1: 16.473,
    y2: 2.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__D",
    x1: 0.782,
    x2: 15.033,
    y1: 16.335,
    y2: 2.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emurgo_svg__E",
    x1: 1.206,
    x2: 15.43,
    y1: 16.74,
    y2: 2.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1055"
  })))));
};
export { SvgEmurgo as ReactComponent };